import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import api from "../api"; // your axios instance

function Category() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch categories from API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get("/Category"); // baseURL already has /api
        setCategories(response.data);
        debugger;
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  // Handlers for actions
  const handleView = (id) => {
    alert(`View category with ID: ${id}`);
    // TODO: navigate to detail page or open modal
  };

  const handleEdit = (id) => {
    alert(`Edit category with ID: ${id}`);
    // TODO: navigate to edit form or open modal
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await api.delete(`/Category/${id}`);
        setCategories(categories.filter((cat) => cat.catID !== id));
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };

  // Define columns for DataGrid
  const columns = [
    { field: "catID", headerName: "ID", width: 100 },
    { field: "catName", headerName: "Category Name", width: 250 },
    {
      field: "actions",
      headerName: "Actions",
      width: 300,
      renderCell: (params) => (
        <>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => handleView(params.row.catID)}
            style={{ marginRight: 8 }}
          >
            View
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            onClick={() => handleEdit(params.row.catID)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleDelete(params.row.catID)}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ height: 500, width: "100%" }}>
      <h2>Category Management</h2>
      <DataGrid
        rows={categories}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10]}
        loading={loading}
        disableSelectionOnClick
        getRowId={(row) => row.catID} // ✅ use catID as unique row id
      />
    </div>
  );
}

export default Category;